export enum ContentRenderMode {
	NORMAL = 'normal',
	SLIDER = 'slider',
	REUSE_SECTION = 'reuseSection',
	REUSE_BLOCK = 'reuseBlock'
}
